import React, { useState, useEffect, useRef} from "react";
import {
  Box,
  Paper,
  TextField,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Autocomplete,
  Select,
  MenuItem,
  FormControl,
  IconButton,
  Grid2,
} from "@mui/material";
import { toast } from "sonner";
import { Iconify } from "../Minimal/src/components/iconify";
import config from "../common/Config";
import "../common/commonStyles.css";

const StockAdjustment = () => {
  const [supplierOptions, setSupplierOptions] = useState([]);
  const [supplierValue, setSupplierValue] = useState("");
  const [supplierInputValue, setSupplierInputValue] = useState("");
  const [productBatch, setProductBatch] = useState([]);
  const [productOptions, setProductOptions] = useState([]);
  const [productFilteredOptions, setProductFilteredOptions] = useState([]);
  const [productValue, setProductValue] = useState(null);
  const [productInputValue, setProductInputValue] = useState("");
  const accessToken = localStorage.getItem("accessToken");
  const token = localStorage.getItem('token');
  const [newProductList, setNewProductList] = useState([]);
  const [tableRows, setTableRows] = useState([]);
  const tableRef = React.useRef(null);
  const [note, setNote] = useState("");
  const [selectedSupplier, setSelectedSupplier] = useState("");
  const productBatchRef = useRef(null);
  const [modalData, setModalData] = useState(null);
  const [netStdGoods, setNetStdGoods] = useState(0);
  const [netVatAmt, setNetVatAmt] = useState(0);
  const [netZeroGoods, setNetZeroGoods] = useState(0);
  const [netGrandTotal, setNetGrandTotal] = useState(0);
  const [netWeight, setNetWeight] = useState(0);
  const [grossWeight, setGrossWeight] = useState(0);
  const [quantityValues, setQuantityValues] = useState({});
  const [productTypeValues, setProductTypeValues] = useState({});

  const productHandleChange = (event, selectedOption) => {
    if (selectedOption) {
      setProductValue(selectedOption);
      fetchAddProductInfo(selectedOption.value);
    } else {
      setProductValue(null);
    }
  };

  const productHandleInputChange = (event, inputValue) => {
    setProductInputValue(inputValue);
    const newFilteredOptions = productOptions.filter((option) =>
      option.label.toLowerCase().includes(inputValue.toLowerCase())
    );
    setProductFilteredOptions(newFilteredOptions);
  };

  const formatNumber = (num) => {
    return parseFloat(num).toFixed(2);
  };


  const handleOpenPastPurchaseModal = (data) => {
    setModalData(data);
    if (productBatchRef.current) {
      productBatchRef.current();
    }
  };

  const fetchSupplierProductInfo = async (supplierid) => {
    const formData = new FormData();
    formData.append("supplier_id", supplierid);
    formData.append("product_id", "");

    const apiUrl = `${config.API_URL}/purchases/get_order_datails`;

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Failed to fetch new product");
      }

      const data = await response.json();

      setNewProductList(data.data);
      let stdGoods = 0;
      let totalVat = 0;
      let zeroGoods = 0;

      // Loop through the API response and create a new row for each product
      const newRows = data.data.map((productData) => {
        // salesAvgQuantity is a one month estimate quantity
        const averageProduct = data.averageData.find(item => item.id === productData.id);
        const salesAvgQuantity = averageProduct ? parseFloat(averageProduct.sales_avg_quantity).toFixed(2) : '0.00';

        const number = parseFloat(salesAvgQuantity);
        const adjustedValue = (number % 1 >= 0.5) ? Math.ceil(number) : Math.floor(number);
        const onOrderData = data.on_order_data.find(item => item.id === productData.id);
        const onOrderQuantity = onOrderData ? parseInt(onOrderData.on_order_data) : '0';
        const stockCount = productData.split == "0" || productData.split == "2" ? parseInt(productData.quantity)
          : parseInt(productData.split_quantity);

        const deficit = parseInt(stockCount) - parseInt(onOrderQuantity) - parseFloat(adjustedValue);

        // salesAvgQuantity is a one month estimate quantity
        const unitCost =
          productData.split === "0" || productData.split === "2"
            ? parseFloat(productData.cost)
            : parseFloat(productData.piece_cost);

        if (parseFloat(productData.rate) > 0) {
          stdGoods += unitCost;
        }

        if (parseFloat(productData.rate) === 0.00) {
          zeroGoods += unitCost;
        }

        let vat = productData.rate !== null ? ((unitCost * 1 * formatNumber(productData.rate)) / 100).toFixed(2) : '';
        totalVat += parseFloat(vat);

        const net_weight = productData.net_weight === null ? 0 : productData.net_weight;
        const gross_weight = productData.gross_weight === null ? 0 : productData.gross_weight;

        return {
          code: productData.code,
          id: productData.id,
          pack: productData.pack,
          price: productData.price,
          piece_cost: productData.piece_cost,
          split: productData.split,
          type: productData.split === "0" || productData.split === "2" ? "box" : "piece",
          split_quantity: productData.split_quantity,
          split_price: productData.split_price,
          name: productData.name,
          size: productData.size,
          cost: productData.cost,
          rate: productData.rate,
          net_weight: net_weight,
          gross_weight: gross_weight,
          quantity: productData.quantity,
          pdtcost: unitCost.toFixed(2),
          order_qty: 1,
          subtotal: (unitCost * 1).toFixed(2),
          vat: vat,
          sales_quantity: parseInt(productData.sales_quantity),
          salesAvgQuantity: adjustedValue,
          onOrderQuantity: onOrderQuantity,
          deficit: deficit,
          total: (unitCost * 1 + (unitCost * 1 * formatNumber(productData.rate !== null ? productData.rate : 0)) / 100).toFixed(2),
          stockCount: stockCount,
        };
      });

      setNetStdGoods(stdGoods);
      setNetVatAmt(totalVat);
      setNetZeroGoods(zeroGoods);

      let GrandTotal = stdGoods + totalVat + zeroGoods;
      setNetGrandTotal(GrandTotal);

      // Update tableRows state with all the new rows
      setTableRows((prevRows) => {
        const updatedRows = [...prevRows, ...newRows];
        newRows.forEach((row) => {
          const productType = row.split == 2 ? "box" : (row.split == 0 ? "box" : "piece");
          setProductTypeValues((prev) => ({
            ...prev,
            [row.id]: productType,
          }));
        });
        return updatedRows;
      });
    } catch (error) {
    }
  };

  const fetchAddProductInfo = async (selectedOption) => {
    const formData = new FormData();

    if (selectedOption) {
      formData.append("product_id", selectedOption);
      const existingProduct = tableRows.find(
        (item) => String(item.id) === String(selectedOption)
      );
      if (existingProduct) {
        toast.error("Product already exists in the list, Please Add Quantity.");
        setProductValue(null);
        return;
      }
    }

    const apiUrl = `${config.API_URL}/purchases/get_order_datails`;

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Failed to fetch new product");
      }

      const data = await response.json();
      const productDataList = Array.isArray(data) ? data : (data.data || []);
      setNewProductList(productDataList);

      if (productDataList.length === 0) {
        toast.error("Could not load product details.");
        setProductValue(null);
        return;
      }

      const averageData = Array.isArray(data) ? [] : (data.averageData || []);
      const onOrderData = Array.isArray(data) ? [] : (data.on_order_data || []);

      const newRows = productDataList.map((productData) => {
        const averageProduct = averageData.find(item => item.id === productData.id);
        const salesAvgQuantity = averageProduct ? parseFloat(averageProduct.sales_avg_quantity).toFixed(2) : '0.00';
        const number = parseFloat(salesAvgQuantity);
        const adjustedValue = (number % 1 >= 0.5) ? Math.ceil(number) : Math.floor(number);
        const orderItem = onOrderData.find(item => item.id === productData.id);
        const onOrderQuantity = orderItem ? parseInt(orderItem.on_order_data) : 0;
        const stockCount = productData.split === "0" || productData.split === "2" ? parseInt(productData.quantity) : parseInt(productData.split_quantity);
        // Calculate the deficit
        const deficit = parseInt(stockCount) - onOrderQuantity - parseFloat(adjustedValue);

        const unitCost =
          productData.split === "0" || productData.split === "2"
            ? parseFloat(productData.cost)
            : parseFloat(productData.piece_cost);

        const net_weight = productData.net_weight === null ? 0 : productData.net_weight;
        const gross_weight = productData.gross_weight === null ? 0 : productData.gross_weight;

        const newRow = {
          code: productData.code,
          id: productData.id,
          pack: productData.pack,
          price: productData.price,
          piece_cost: productData.piece_cost,
          split: productData.split,
          type: productData.split === "0" || productData.split === "2" ? "box" : "piece",
          split_quantity: productData.split_quantity,
          split_price: productData.split_price,
          name: productData.name,
          size: productData.size,
          cost: productData.cost,
          rate: productData.rate,
          net_weight: net_weight,
          gross_weight: gross_weight,
          quantity: productData.quantity,
          pdtcost: unitCost.toFixed(2), // formatted unit cost
          order_qty: 1,
          subtotal: (unitCost * 1).toFixed(2), // subtotal calculation
          vat: ((unitCost * 1 * formatNumber(productData.rate)) / 100).toFixed(2), // VAT calculation
          sales_quantity: parseInt(productData.sales_quantity),
          salesAvgQuantity: adjustedValue,
          onOrderQuantity: onOrderQuantity,
          deficit: deficit,
          total: (unitCost * 1 + (unitCost * 1 * formatNumber(productData.rate)) / 100).toFixed(2), // total including VAT
          stockCount: stockCount,
        };

        return newRow; // Return the new row object
      });

      // Set the updated table rows in the state
      setTableRows((prevRows) => {
        const updatedRows = [...prevRows, ...newRows];
        newRows.forEach((row) => {
          const productType = row.split == 2 ? "box" : (row.split == 0 ? "box" : "piece");
          setProductTypeValues((prev) => ({
            ...prev,
            [row.id]: productType,
          }));
        });
        return updatedRows;
      });
      setProductValue(null);

    } catch (error) {
    }
  };

  const fetchProductList = async (supplierId) => {
    const formData = new FormData();
    if (supplierId != null && supplierId !== "") {
      formData.append("supplier_id", supplierId);
    }
    const apiSalesRouteUrl = `${config.API_URL}/purchases/getProducts`;
    try {
      const response = await fetch(apiSalesRouteUrl, {
        method: "POST",
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      });

      const data = await response.json();
      const products = data.products || [];
      const formattedOptions = products.map((item) => ({
        label: item.name + "(" + item.code + ")",
        value: item.id,
      }));
      setProductOptions(formattedOptions);
      setProductFilteredOptions(formattedOptions);
    } catch (error) {
    }
  };

  useEffect(() => {
    if (accessToken === null) {
      window.location.href = `${config.BASE_URL}/login`;
      return;
    }
    fetchProductList("");
  }, []);



  const handleCancel = (id) => {
    setTableRows((prevRows) => prevRows.filter((row) => row.id !== id));
    setQuantityValues((prev) => {
      const updated = { ...prev };
      delete updated[id];
      return updated;
    });
    setProductTypeValues((prev) => {
      const updated = { ...prev };
      delete updated[id];
      return updated;
    });
  };

  const handleQuantityChange = (id, value) => {
    setQuantityValues((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const handleProductTypeChange = (id, value) => {
    setProductTypeValues((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const submitFormData = async () => {
    if (tableRows.length === 0) {
      toast.error("Please add at least one product.");
      return;
    }

    const formData = new FormData();

    tableRows.forEach((row) => {
      formData.append("product_id[]", row.id);
      const productType = productTypeValues[row.id] || (row.split == 2 ? "box" : (row.split == 0 ? "box" : "piece"));
      formData.append("producttype[]", productType);
      formData.append("qty[]", quantityValues[row.id] || "");
      formData.append("box_qty[]", parseInt(row.quantity));
      formData.append("pic_qty[]", parseInt(row.split_quantity));
    });

    const apiSalesRapUrl = `${config.API_URL}/products/stock_Adjustment`;
    try {
      const response = await fetch(apiSalesRapUrl, {
        method: "POST",
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      });

      const data = await response.json();
      if (data.success == true) {
        toast.success("Product stock updated successfully.");
        setTimeout(() => {
          setTableRows([]);
          setQuantityValues({});
          setProductTypeValues({});
          setProductValue(null);
        }, 1500);
      } else {
        toast.error("Product stock updated failed");
      }
    } catch (error) {
      toast.error("Error updating stock");
    }
  };

  return (
    <>
      <Box className="page-container">
        <Paper className="paper-style" >
          <Box sx={{ px: 2, py: 1.2 }}>
            <Grid2 container spacing={2} display="flex" justifyContent="space-between" alignItems="center" gap={2}>
              <Typography className="page-title">
                Stock Adjustment
              </Typography>
              <Grid2 size={{ xs: 12, md: 4 }}>
                <Autocomplete
                  options={productFilteredOptions}
                  value={productValue}
                  className="input-border"
                  onChange={productHandleChange}
                  onInputChange={productHandleInputChange}
                  getOptionLabel={(option) => option.label || ""}
                  isOptionEqualToValue={(option, value) => option.value === value?.value}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select Product"
                      size="small"
                      className="input-border"
                    />
                  )}
                />
              </Grid2>
            </Grid2>
          </Box>
            <TableContainer>
              <Table size="medium" className="table-cell-border" sx={{ tableLayout: "fixed" }}>
                <TableHead>
                  <TableRow className="table-cell-header">
                    <TableCell
                      sx={{
      
                        width: "150px",
                        minWidth: "150px",
                      }}
                    >
                      Code
                    </TableCell>
                    <TableCell
                      sx={{
                        width: "250px",
                        minWidth: "250px",
                      }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      sx={{
                
                        width: "120px",
                        minWidth: "120px",
                        textAlign: "center",
                      }}
                    >
                      Product Type
                    </TableCell>
                    <TableCell
                      sx={{
                        width: "100px",
                        minWidth: "100px",
                        textAlign: "center",
                      }}
                    >
                      Box QTY
                    </TableCell>
                    <TableCell
                      sx={{
                
                        width: "100px",
                        minWidth: "100px",
                        textAlign: "center",
                      }}
                    >
                      Piece QTY
                    </TableCell>
                    <TableCell
                      sx={{
                        width: "120px",
                        minWidth: "120px",
                      }}
                    >
                      QTY
                    </TableCell>
                    <TableCell
                      sx={{
                        width: "80px",
                        minWidth: "80px",
                        textAlign: "center",
                      }}
                    >
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tableRows.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={7} sx={{ textAlign: "center", py: 3, color: "#637381" }}>
                        No product added
                      </TableCell>
                    </TableRow>
                  ) : (
                    tableRows.map((row) => (
                      <TableRow
                        key={row.id}
                        className="table-cell-style"
                        hover
                        sx={{
                          "&:hover": {
                            backgroundColor: "rgba(145, 158, 171, 0.08)",
                          },
                          "&:last-child td": {
                            borderBottom: "none",
                          },
                      
                        }}
                      >
                        <TableCell
                        >
                          {row.code}
                        </TableCell>
                        <TableCell
                 
                        >
                          {row.name} - {row.size}
                        </TableCell>
                        <TableCell
                          sx={{ textAlign: "center",
                  
                          }}
                        >
                          {row.split == 2 ? (
                            <FormControl size="small" fullWidth>
                              <Select
                                value={productTypeValues[row.id] || "box"}
                                onChange={(e) => handleProductTypeChange(row.id, e.target.value)}
                                sx={{
                                  fontSize: "0.875rem",
                                  backgroundColor: "#f5f7fa",
                                  "&:hover": {
                                    backgroundColor: "#fff",
                                  },
                                  "&.Mui-focused": {
                                    backgroundColor: "#fff",
                                  },
                                }}
                              >
                                <MenuItem value="box">Box</MenuItem>
                                <MenuItem value="piece">Piece</MenuItem>
                              </Select>
                            </FormControl>
                          ) : (
                            row.split == 0 ? "Box" : "Piece"
                          )}
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: "center",
                          }}
                        >
                          {parseInt(row.quantity)}
                        </TableCell>
                        <TableCell
                          sx={{
               
                            textAlign: "center",
               
                          }}
                        >
                          {parseInt(row.split_quantity)}
                        </TableCell>
                        <TableCell
                   
                        >
                          <TextField
                            type="text"
                            className="input-border"
                            value={quantityValues[row.id] || ""}
                            onChange={(e) => handleQuantityChange(row.id, e.target.value)}
                            size="small"
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                backgroundColor: "#f5f7fa",
                                fontSize: "0.875rem",
                                "&:hover": {
                                  backgroundColor: "#fff",
                                },
                                "&.Mui-focused": {
                                  backgroundColor: "#fff",
                                },
                              },
                            }}
                            inputProps={{
                              style: { textAlign: "center", padding: "8px" },
                            }}
                          />
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: "center",
                          }}
                        >
                          <IconButton
                            onClick={() => handleCancel(row.id)}
                            size="small"
                            sx={{
                              color: "#d32f2f",
                              "&:hover": {
                                backgroundColor: "rgba(211, 47, 47, 0.08)",
                              },
                            }}
                          >
                            <Iconify icon="eva:trash-2-outline" width={20} />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            <Box sx={{ mt: 2, mb: 2, px: 2, display: "flex", justifyContent: "flex-end" }}>
              <Button
                variant="contained"
                className="button-variant-contained"
                onClick={submitFormData}
              >
                Submit
              </Button>
            </Box>
        
        </Paper>
      </Box>
   
    </>
  );
};
export default StockAdjustment;
